import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { CircularProgress, Typography, makeStyles } from '@material-ui/core';
import usePaymentConfiguration from '../../hooks/usePaymentConfiguration';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    height: '60vh',
    textAlign: 'center',
  },
  spinner: {
    marginBottom: theme.spacing(2),
  },
}));

const PaymentCallback = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { linkPayment } = usePaymentConfiguration();

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    
    if (code && state && state.startsWith('fasterstore-')) {
      linkPayment(code, state).finally(() => {
        // Redirigir a configuraciones después de procesar
        history.push('/configuraciones');
      });
    } else {
      // Si no hay parámetros válidos, redirigir a configuraciones
      history.push('/configuraciones');
    }
  }, [location, linkPayment, history]);

  return (
    <div className={classes.root}>
      <CircularProgress size={60} className={classes.spinner} />
      <Typography variant="h6">
        Procesando configuración de Mercado Pago...
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Te redirigiremos en un momento.
      </Typography>
    </div>
  );
};

export default PaymentCallback; 